import About from './components/About';
import Carousel2 from './components/Carousel2';
import FaqSection from './components/Faqs';
import Footer from './components/Footer';
import Hero from './components/Hero';
import Navbar from './components/Navbar';

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <About />
      <Carousel2 />
      <FaqSection />
      <Footer />
    </>
  );
}

export default App;
